import { Graphic } from './graphic.model';

export class GraphicSettings{
    settings:Array<Graphic>;
}